import type { SignalsResponse } from '../../domain/signal';
import { HttpClient } from '../../services/HttpClient';

const SIGNALS_API_URL = '/sales-extension/api/signals';

export const signalsApi = {
  getSignals: (companyDomain: string) => {
    const searchParams = new URLSearchParams({ domain: companyDomain });
    return HttpClient.get<SignalsResponse>(`${SIGNALS_API_URL}?${searchParams.toString()}`);
  },
};
